import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

import { BusinessOfferingsFeatures } from './data/data';

const BusinessOfferings = () => {
  return (
    <section data-cy="business-offerings">
      <LandingPageFeatures
        eyebrow="business_offerings_header"
        features={BusinessOfferingsFeatures}
        imageGradientBg={{
          className: 'bg-sandstone-300',
          gradients: [],
        }}
        textColor="sandstone-500"
      />
    </section>
  );
};

export default BusinessOfferings;
